import React from 'react';
import { Filter, TextInput, SelectInput } from 'react-admin';
import { InputAdornment } from '@material-ui/core';
import { Search as SearchIcon } from '@material-ui/icons';
import { status } from '../../utils/choices';

const PlotFilters = (props) => {
  return (
    <Filter {...props}>
      <TextInput
        alwaysOn
        source="name"
        label="Plot name"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <SearchIcon color="disabled" />
            </InputAdornment>
          ),
        }}
      />

      <SelectInput source="status" choices={status} alwaysOn allowEmpty />
    </Filter>
  );
};

export default PlotFilters;
